/**
 * Session variant_id — one id per browser tab/session, stored in localStorage.
 * Reuse existing value; only create when missing (e.g. after logout cleared it).
 */

function getRandomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

/** Read variant id from storage (trade-client uses variantId; app-suite web may use variant_id). */
export function readStoredVariantId() {
  if (typeof window === 'undefined') return null;
  const vid =
    localStorage.getItem('variantId') || localStorage.getItem('variant_id');
  if (!vid || vid === 'undefined' || vid === 'null') return null;
  return String(vid).slice(0, 64);
}

export function createSessionVariantId() {
  // Always positive: ids are surfaced in audit logs / URLs, negatives are confusing.
  const min = 1;
  const max = Number.MAX_SAFE_INTEGER;
  return String(getRandomNumber(min, max)).slice(0, 64);
}

/**
 * @param {{ forceNew?: boolean }} [opts] — forceNew after direct-login handoff (old variant logged out)
 */
export function getOrCreateSessionVariantId(opts = {}) {
  const { forceNew = false } = opts;
  if (!forceNew) {
    const existing = readStoredVariantId();
    if (existing) return existing;
  }
  const next = createSessionVariantId();
  persistSessionVariantId(next);
  return next;
}

export function persistSessionVariantId(variantId) {
  if (typeof window === 'undefined' || !variantId) return;
  const v = String(variantId).slice(0, 64);
  localStorage.setItem('variantId', v);
}
